<template>
  <div class="root">
    <div class="root-title">热门供应</div>
    <div class="supply-view-bg">
        <div v-for="(item, index) in supply" :key="index" :class="index === supply.length-1 ? 'supply-view border-none' : 'supply-view'">
            <a href="#" class="supply-name" @click="categoryItemClick(item.category)">{{item.category}}</a>
            <div class="cate-list">
                <a href="#" class="cate-names" v-for="(supply, i) in item.categoryData" :key="i"
                  @click="categoryItemClick(supply.categoryName)">{{supply.categoryName}}</a>
            </div>

        </div>
    </div>
    <el-dialog
        :visible.sync="dialogVisible"
        width="30%">
        <span>{{dialogTitle}}</span>
        <span slot="footer" class="dialog-footer">
            <el-button type="primary" @click="dialogVisible = false">确定</el-button>
        </span>
    </el-dialog>

  </div>
</template>
<script>
import {mapMutations, mapGetters} from 'vuex'
import {
    getTypeList
} from '@/api/home/supply.js'
export default {
  data () {
    return {
      dialogVisible: false,
      dialogTitle: '',
      supply: [{
        category: '蔬菜',
        categoryData: [
          { categoryName: '葱姜蒜类', },
          { categoryName: '根茎菜类', },
          { categoryName: '叶菜类', },
          { categoryName: '菌', },
          { categoryName: '茄果菜类', },
          { categoryName: '食用菌', },
          { categoryName: '瓜菜类', },
          { categoryName: '芽苗类', },
        ],
      }, {
        category: '农机农资',
        categoryData: [
          { categoryName: '农用机械设备', },
          { categoryName: '肥料', },
          { categoryName: '农药', },
          { categoryName: '饲料', },
          { categoryName: '农用百货', },
          { categoryName: '排灌设备', },
          { categoryName: '大棚及温室', },
          { categoryName: '仓储设备', },
        ],
      }, {
        category: '粮油米面',
        categoryData: [
          { categoryName: '面', },
          { categoryName: '米', },
          { categoryName: '油', },
          // { categoryName: '食用油', },
          // { categoryName: '调味品', },
          // { categoryName: '香辛料', },
          // { categoryName: '谷物粉淀粉', },
          // { categoryName: '豆制品', },
          // { categoryName: '面食米食', },
          // { categoryName: '油料作物', },
          // { categoryName: '豆类作物', },
        ],
      }, {
        category: '种子种苗',
        categoryData: [
          { categoryName: '水果种苗', },
          { categoryName: '花草类种子', },
          { categoryName: '蔬菜种子', },
          { categoryName: '水果类种子', },
          { categoryName: '粮油类种子', },
          { categoryName: '苗木类种子', },
          { categoryName: '药材类种子', },
          { categoryName: '食用菌种', },
        ],
      }, {
        category: '农副加工',
        categoryData: [
          { categoryName: '糖', },
          { categoryName: '汤', },
          { categoryName: '菌', },
          { categoryName: '休闲食品', },
          { categoryName: '蜜', },
          { categoryName: '其他', },
          // { categoryName: '干果坚果', },
          // { categoryName: '茶叶', },
          // { categoryName: '肉制品加工', },
          // { categoryName: '水产加工', },
          // { categoryName: '营养滋补', },
          // { categoryName: '速食品', },
          // { categoryName: '酒', },
          // { categoryName: '蔬菜加工', },
        ],
      }, {
        category: '水产',
        categoryData: [
          { categoryName: '水产种苗', },
          { categoryName: '虾类', },
          { categoryName: '贝类', },
          { categoryName: '食用鱼类', },
          { categoryName: '蟹类', },
          { categoryName: '软体类', },
          { categoryName: '藻类', },
          { categoryName: '观赏鱼类', },
        ],
      }, {
        category: '水果',
        categoryData: [
          { categoryName: '热带水果', },
          { categoryName: '柑橘类', },
          { categoryName: '浆果类', },
          { categoryName: '瓜果类', },
          { categoryName: '核果仁果', },
        ],
      }, {
        category: '禽畜肉蛋',
        categoryData: [
          { categoryName: '禽畜苗', },
          { categoryName: '肉类', },
          { categoryName: '蛋类', },
          { categoryName: '活畜', },
          { categoryName: '活禽', },
          { categoryName: '特种类', },
          { categoryName: '鸟类', },
          { categoryName: '虫类', },
        ],
      }],
    }
  },
  computed: {
    ...mapGetters([
        'searchObj',
        'homeSelectIndex'
    ])
  },
  mounted () {
    this.getTypeList()
  },
  methods: {
    ...mapMutations({
        setSearchObj: 'SET_SEARCHOBJ',
        setHomeSelectIndex: 'SET_HOMESELECTINDEX'
    }),
    async getTypeList () {
        const response = await getTypeList()
        const res = response.data
      if (res.code === '200') {
        res.data.forEach(item => {
            const id = item.id
            if (id === 1) { // 农副加工
              this.supply[4].category = item.primaryName
              this.supply[4].categoryData = []
              const childrenTypes = item.childrenType
              childrenTypes.forEach(ct => {
                    this.supply[4].categoryData.push({'categoryName': ct.bigName})
                })
            } else if (id === 2) { // 粮油米面
              this.supply[2].category = item.primaryName
              this.supply[2].categoryData = []
              const childrenTypes = item.childrenType
              childrenTypes.forEach(ct => {
                    this.supply[2].categoryData.push({'categoryName': ct.bigName})
                })
            }
        })
      }
    },
    // 拓展分类点击
    categoryItemClick (item) {
      this.setSearchObj({
        keyword: item,
        searchVal: '商品'
      })
      this.setHomeSelectIndex(3)
      if (this.$route.name !== 'search') {
        this.$router.push({
          path: '/activity/search'
        })
      }
    },
  }
}
</script>
<style lang="scss" scoped>
.root{
  width: 100%;
  padding: 1px 8vw;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;

  .root-title {
    height: 84px;
    display: flex;
    align-items: center;
    background-color: #fff;
    padding: 0 16px;

    color: #222;
    font-size: 18px;
    font-weight: 600;
  }
  .supply-view-bg {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    height: 160px;
    width: 100%;
    padding: 0px 16px 30px 16px;
    box-sizing: border-box;
    background-color: #fff;

    .supply-view {
        height: 100%;
        display: flex;
        flex-direction: column;
        // border-right: 1px solid #e9e9e9;
        padding: 0 6px;
        box-sizing: border-box;
        .supply-name {
            font-family: PingFangSC-Medium;
            font-size: 14px;
            color: #444;
            letter-spacing: 0;
        }
        .supply-name:hover {
            color: #4dc832;
        }
        .cate-list {
            margin-top: 10px;
            height: 96px;
            width: 118px;
            flex-wrap: wrap;
            align-content: flex-start;
            justify-content: space-between;
            display: flex;

            .cate-names {
                width: 50px;
                font-family: PingFangSC-Regular;
                font-size: 12px;
                color: #646464;
                letter-spacing: 0;
                line-height: 24px;
                white-space: nowrap;
                text-overflow: ellipsis;
                overflow: hidden;
                // margin-right: 10px;
            }
            .cate-names:hover {
                color: #4dc832;
            }
        }

    }
    .border-none {
        border: none;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/hot.vue